import MPAAddSuperAdminUser from './MPAAddSuperAdminUser';

export default MPAAddSuperAdminUser;
